import moment from 'moment'

// Lab/visit helpers ported 1:1 from the mobile app so this admin debug view
// matches what a patient sees on their phone (PatientHIEBookingHistory ->
// PatientHIEBookingDetail -> DocumentDisplay).

// Shape raw HIE docs into the visit list, same as mobile
// PatientHIEBookingHistory/hooks.js.
export const processVisits = (docs) => {
  if (!Array.isArray(docs)) {
    return []
  }
  return docs
    .filter((e) => e && Array.isArray(e.diagnoses) && e.diagnoses.length > 0)
    .map((d) => ({
      diagId: d.id,
      doctorName: d.doctorName || 'ไม่ระบุแพทย์',
      icd10Name: (d.diagnoses[0] && d.diagnoses[0].icd10Name) || '',
      icd10ThaiName: (d.diagnoses[0] && d.diagnoses[0].icd10ThaiName) || 'ติดตามการรักษา',
      visitDateTime: d.visitDateTime,
      department: d.departmentName,
      billingItems: d.billingItems || [],
      labResults: d.labResults || [],
      drugs: d.drugs || [],
      hasLab: Array.isArray(d.labResults) && d.labResults.length > 0,
      hasDrug: Array.isArray(d.drugs) && d.drugs.length > 0,
    }))
    .sort((a, b) => new Date(b.visitDateTime) - new Date(a.visitDateTime))
    .filter((v) => moment(v.visitDateTime).isBefore(moment()))
}

// Group a visit's labResults by formName into
// [{ type, data: [{ name, result, ref, group, formName }] }].
// Equivalent net output to PatientHIEBookingDetail.storeLabResults().
export const groupLabResults = (labResults) => {
  if (!Array.isArray(labResults)) {
    return []
  }
  const byForm = {}
  labResults.forEach((r) => {
    const formName = (r && r.labHeadData && r.labHeadData.formName) || 'ไม่ระบุ'
    const rows = ((r && r.labReportData) || []).map((item) => ({
      name: item.labItemsName,
      result: item.labOrderResult,
      ref: item.labItemsNormalValueRef,
      group: item.labgrpName,
      formName,
    }))
    byForm[formName] = (byForm[formName] || []).concat(rows)
  })
  return Object.keys(byForm).map((type) => ({ type, data: byForm[type] }))
}

// Collapse exact-duplicate lab rows (same name + result + ref) into one.
// Ported from DocumentDisplay.dedupeLabRows().
export const dedupeLabRows = (rows) => {
  if (!Array.isArray(rows)) {
    return []
  }
  const seen = new Set()
  const deduped = []
  rows.forEach((item) => {
    const key = [
      String((item && item.name) || '').trim(),
      String((item && item.result) || '').trim(),
      String((item && item.ref) || '').trim(),
    ].join('|')
    if (seen.has(key)) {
      return
    }
    seen.add(key)
    deduped.push(item)
  })
  return deduped
}

// true (in range) / false (out of range) / null (cannot compare).
// Ported from DocumentDisplay.checkResultInRange().
export const checkResultInRange = (result, ref) => {
  if (!result || !ref) {
    return null
  }
  const resultNum = parseFloat(String(result).replace(/,/g, ''))
  if (Number.isNaN(resultNum)) {
    return null
  }
  const refMatch = ref.match(/([\d,.]+)\s*-\s*([\d,.]+)/)
  if (!refMatch) {
    return null
  }
  const min = parseFloat(refMatch[1].replace(/,/g, ''))
  const max = parseFloat(refMatch[2].replace(/,/g, ''))
  if (Number.isNaN(min) || Number.isNaN(max)) {
    return null
  }
  return resultNum >= min && resultNum <= max
}

export const formatVisitDateTime = (value) => {
  if (!value) {
    return ''
  }
  const m = moment(value)
  if (!m.isValid()) {
    return String(value)
  }
  return `${m.format('D MMM YYYY')} (${m.format('HH:mm')} น.)`
}
